import React from 'react';
import { motion } from 'framer-motion';

const leaders = [
  {
    role: 'Technology Leadership',
    title: 'IT Leader — 22 Years of Experience',
    bio: 'Two decades of leading system architecture, enterprise software delivery, and engineering teams — now applying that experience to AI-native product design at Ufeus.',
  },
  {
    role: 'People & Talent',
    title: 'HR & Recruitment Specialist — 15 Years of Experience',
    bio: 'A seasoned HR and recruitment specialist with 15 years of experience building teams, shaping culture, and identifying talent beyond conventional credentials.',
  },
];

export default function Founders() {
  return (
    <section id="founders" className="py-24 px-6 md:px-8" style={{ backgroundColor: 'var(--bg-subtle)' }}>
      <div className="container-premium">
        <div className="eyebrow mb-4">Leadership</div>
        <h2 className="t-h1 font-display mb-4 max-w-2xl" style={{ color: 'var(--text-primary)' }}>
          Founded by an IT Leader
        </h2>
        <p className="t-body mb-14 max-w-2xl" style={{ color: 'var(--text-secondary)' }}>
          Not leaders — a leader. Ufeus is guided by hands-on experience, not committee, and
          backed by a partner who knows how to build the teams that make it real.
        </p>

        <div className="grid md:grid-cols-2 gap-6">
          {leaders.map((l, i) => (
            <motion.div
              key={l.role}
              className="card p-8"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.6, delay: i * 0.12 }}
            >
              <div className="t-label mb-3" style={{ color: 'var(--accent)' }}>{l.role}</div>
              <h3 className="t-h2 mb-4" style={{ color: 'var(--text-primary)' }}>{l.title}</h3>
              <p className="t-body" style={{ color: 'var(--text-secondary)' }}>{l.bio}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
